import { useEffect, useState } from "react";
import { Instagram, Phone, Menu, X, Leaf } from "lucide-react";
import { Button } from "./ui/button";
import { whatsappUrl, instagramUrl } from "../mock";

const navItems = [
  { label: "A Oportunidade", href: "#oportunidade" },
  { label: "Produtos", href: "#produtos" },
  { label: "Seus Ganhos", href: "#ganhos" },
  { label: "Seu Gestor", href: "#executivo" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0a2e18]/95 backdrop-blur-md shadow-lg" : "bg-[#0a2e18]/80 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 grid place-items-center shadow-md">
            <Leaf className="w-5 h-5 text-white" />
          </div>
          <div className="leading-tight">
            <div className="text-white font-bold text-lg tracking-tight">
              iGreen <span className="text-emerald-400">Energy</span>
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {navItems.map((it) => (
            <a
              key={it.href}
              href={it.href}
              className="text-slate-200 hover:text-emerald-400 text-sm font-medium transition-colors"
            >
              {it.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <a
            href={instagramUrl}
            target="_blank"
            rel="noreferrer"
            className="hidden md:grid w-9 h-9 rounded-full border border-white/15 place-items-center text-slate-200 hover:text-emerald-400 hover:border-emerald-400/40 transition-colors"
            aria-label="Instagram"
          >
            <Instagram className="w-4 h-4" />
          </a>

          <a
            href={whatsappUrl}
            target="_blank"
            rel="noreferrer"
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-full border border-emerald-400/50 text-emerald-300 hover:bg-emerald-400/10 text-sm font-semibold transition-colors"
          >
            <Phone className="w-4 h-4" /> Quero Ser Cliente
          </a>

          <a
            href="#contato"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full btn-gold text-sm"
          >
            <Phone className="w-4 h-4" /> <span className="hidden sm:inline">Quero Ser Licenciado</span><span className="sm:hidden">Licenciado</span>
          </a>

          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden text-white hover:bg-white/10"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </Button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0a2e18] border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-3">
            {navItems.map((it) => (
              <a
                key={it.href}
                href={it.href}
                onClick={() => setOpen(false)}
                className="text-slate-200 hover:text-emerald-400 text-sm font-medium py-2 border-b border-white/5"
              >
                {it.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
